import React from "react";
import { Link, useHistory } from "react-router-dom";
import homelabSeries from "../../pages/labs/digital-forensics-homelab-series";

const SeriesNav = ({ current }) => {
  const history = useHistory();
  const index = homelabSeries.findIndex((part) => part.slug === current);
  const prev = index > 0 ? homelabSeries[index - 1] : null;
  const next = index < homelabSeries.length - 1 ? homelabSeries[index + 1] : null;

  const handleJump = (e) => {
    const slug = e.target.value;
    if (slug && slug !== current) history.push(slug);
  };

  return (
    <div className="series-nav">
      <div className="series-nav__jump">
        <span className="series-nav__count">
          Part {index + 1} of {homelabSeries.length}
        </span>
        <select
          className="series-nav__select"
          value={current}
          onChange={handleJump}
          aria-label="Jump to part"
        >
          {homelabSeries.map((part, i) => (
            <option key={part.slug} value={part.slug}>
              {`Part ${i + 1}: ${part.title}`}
            </option>
          ))}
        </select>
      </div>
      <div className="series-nav__links">
        {prev ? (
          <Link
            to={prev.slug}
            className="series-nav__link series-nav__link--prev"
          >
            <i className="fa-solid fa-arrow-left"></i>&nbsp;{prev.title}
          </Link>
        ) : (
          <span className="series-nav__link series-nav__link--disabled">
            <i className="fa-solid fa-arrow-left"></i>&nbsp;Start
          </span>
        )}
        {next ? (
          <Link
            to={next.slug}
            className="series-nav__link series-nav__link--next"
          >
            {next.title}&nbsp;<i className="fa-solid fa-arrow-right"></i>
          </Link>
        ) : (
          <span className="series-nav__link series-nav__link--disabled">
            More coming soon&nbsp;<i className="fa-solid fa-arrow-right"></i>
          </span>
        )}
      </div>
    </div>
  );
};

export default SeriesNav;
